import React from 'react'
import CompreQuestion from './CompreQuestion'

const Comprehension = () => {
  return (
    <div>
      
        <CompreQuestion/>
    </div>
  )
}

export default Comprehension